import React from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import qs from 'qs';

import {
  searchDeposits as searchDepositsAc,
  clearRedirect as clearRedirectAc,
  clearSearch as clearSearchAc,
  getPublications as getPublicationsAc,
  getGeologicAges as getGeologicAgesAc,
  deleteDeposit as deleteDepositAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
  clearDepositData as clearDepositDataAc,
} from '../../../../../../redux/tsunamis/deposits/search/depositSearchActions';


import { resolveSearchParameters } from '../search/depositSearchParameterNameResolver';

import { isDataManager } from '../../../../../../role/roleUtils';
import { Loading } from '../../../../../loadbar/Loading';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import { DepositDataGrid } from './DepositDataGrid';
import { withUser } from '../../../../../auth/withUser';

class DepositSearchResultsPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParameters: {},
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Deposit Reference Results';
    const {
      clearDepositData,
      getGeologicAges,
      getPublications,
      searchDeposits,
      clearRedirect,
      searchRedirect,
      location: { search },
    } = this.props;
    clearDepositData();
    getGeologicAges();
    getPublications();
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      searchDeposits({ queryParameters });
    } else {
      clearRedirect();
    }
    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearSearch } = this.props;
    clearSearch();
  }

  render() {
    const {
      deposits,
      fetched,
      deleting,
      authorities,
      publications,
      geologicAges,
      sort,
      sortData,
      visibleColumns,
      toggleColumns,
      deleteDeposit,
      searchDeposits,
    } = this.props;
    const { queryParameters } = this.state;
    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters,
      geologicAges,
      publicationTypes: publications,
    });

    return (
      <div className="haz-results-container haz-page-container">

        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>

                <div className="doiCitation">
                  <span id="doiReference">
                    <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G10146.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Deposit Information" aria-label="Deposit Information">Please cite this data when used as a source</a>
                  </span>
                </div>

                <CardTitle tag="h2">{`Deposit References - ${deposits.size} Results Found`}</CardTitle>

                <DepositDataGrid
                  deposits={deposits}
                  dataManager={dataManager}
                  sortData={sortData}
                  sort={sort}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteDeposit={deleteDeposit}
                  onDeleteCloseModal={() => searchDeposits({ queryParameters })}
                />

              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

DepositSearchResultsPageUnwrapped.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  deposits: ImmutablePropTypes.list.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  searchDeposits: PropTypes.func.isRequired,
  clearRedirect: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  clearDepositData: PropTypes.func.isRequired,
  deleteDeposit: PropTypes.func.isRequired,
  getPublications: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  getGeologicAges: PropTypes.func.isRequired,
  publications: ImmutablePropTypes.list.isRequired,
  geologicAges: ImmutablePropTypes.list.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['depositSearchPage', 'fetched']),
    state.getIn(['depositSearchPage', 'fetchedPublications']),
    state.getIn(['depositSearchPage', 'fetchedGeologicAges']),
  ].every(v => v),
  deleting: state.getIn(['depositSearchPage', 'deleting']),
  deposits: state.getIn(['depositSearchPage', 'deposits']),
  searchRedirect: state.getIn(['depositSearchPage', 'searchRedirect']),
  sort: state.getIn(['depositSearchPage', 'sort']),
  visibleColumns: state.getIn(['depositSearchPage', 'visibleColumns']),
  publications: state.getIn(['depositSearchPage', 'publications']),
  geologicAges: state.getIn(['depositSearchPage', 'geologicAges']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchDeposits: searchDepositsAc,
  clearRedirect: clearRedirectAc,
  clearSearch: clearSearchAc,
  clearDepositData: clearDepositDataAc,
  deleteDeposit: deleteDepositAc,
  getPublications: getPublicationsAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
  getGeologicAges: getGeologicAgesAc,
}, dispatch);


export const DepositSearchResultsPage = withUser(connect(mapStateToProps, mapDispatchToProps)(DepositSearchResultsPageUnwrapped));
